export default "__VITE_ASSET__CFariwEb__"